export type TMenu = {
  label     : string | React.ReactNode;
  key       : string;
  children? : TMenu[];
  type      : string;
};

export const getMenuItem = (
  label     : string | React.ReactNode,
  key       : string,
  children? : TMenu[],
  type?     :  "group",
): TMenu => ({
  label,
  key,
  type,
  children, 
}) as TMenu;